import { render, staticRenderFns } from "./WfDevPermissionList.vue?vue&type=template&id=091d2038&scoped=true&"
import script from "./WfDevPermissionList.vue?vue&type=script&lang=js&"
export * from "./WfDevPermissionList.vue?vue&type=script&lang=js&"
import style0 from "./WfDevPermissionList.vue?vue&type=style&index=0&id=091d2038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091d2038",
  null
  
)

export default component.exports